<template>
  <div class="page">
    <top-header></top-header>
    <div class="cont-box">
      <b-container fluid style="margin-top:5%;">
        <b-row class="mt-3 mb-2">
          <b-col class="col-md-6 col-sm-6 col-xs-6">
            <h3 class="text-white">Manage Complaints <spna style="font-size: 15px;">{{timeData}}</spna></h3>
          </b-col>
          <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
            <b-button
              variant="dark"
              pill
              class="mr-2"
              v-if="$root.chkperm('page_complaint', 'add')"
              @click="showAddModal()"
              >Add Complaint</b-button
            >
            
          </b-col>


          
        </b-row>
      </b-container>
      <b-container fluid>
        <b-row>
          <b-col class="col-md-12 col-sm-12 col-xs-12">
            <div class="container-box">
              <b-row class="mt-4 px-3">
              <b-col>
                <b-form inline>
                  <b-form-group>                
                  <label for="inline-form-input-name" class="mr-sm-2 justify-left">From: </label>
                  <b-form-datepicker
                    v-model="datefrom"
                    class="mr-sm-2"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  ></b-form-datepicker>
                  </b-form-group>
                  <b-form-group>
                  <label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
                  <b-form-datepicker
                    v-model="dateto"
                    class="mr-sm-2"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  ></b-form-datepicker>
                  </b-form-group>                  
                  <b-button @click="datefilter()" size="sm" class="mt-4">Show</b-button>                
                </b-form>
              </b-col>
              <b-col class="text-right"> 
                <b-button variant="dark"  size="sm"  @click="notClosecomplaintslist()" :class="closestatus === 0 ? 'active' : ''">Not Close Comp.</b-button>
                <b-button variant="dark"  size="sm "  @click="todaycomplaintslist()" class="ml-2" :class="closestatus === '' ? 'active' : ''">Todays Comp.</b-button>
              </b-col>
              <b-col class="text-right"> 
               <!--  <b-button variant="dark" pill @click="downloadcsv()">Export</b-button> <b-button variant="dark" pill @click="downloadcsv()">Export</b-button> -->
                <!-- <b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button> -->
					      <b-button variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button>
              
              </b-col>
              </b-row>
              <b-row class="mt-4 ml-2 mr-2 px-0">
                <b-col lg="2" sm="12">
                  <span class="mr-2">Show</span>
                  <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                  </b-form-select>
                  <span class="ml-2">entries</span>
                </b-col>
                <b-col lg="7" sm="12" class="text-center space-between">
											<span class="mr-2">Filters</span>
											<b-form-select v-model="selectedfilter" :options="subjectoptionsFilter" size="sm" class="w-20" @change="onFilterChange()">
											</b-form-select>
											<span class="ml-2 mr-1">Status</span>
											<b-form-select v-model="networkfilter" :options="statusOptionsfilter" size="sm" class=" w-20" @change="onFilterChange()">                       
											</b-form-select>


                     <!--  <span class="ml-2 mr-1">Ward</span> -->
                      <VSelect v-model="wardfilter" :options="wardfilterlist" :searchable="true" defaultTitle="All Wards" size="sm" class=" w-20 custom-select custom-select-sm ml-2" @input="onFilterChangeward()">
                      </VSelect>


                      <!-- <span class="ml-2 mr-1">Supervisor</span> -->
                      <VSelect v-model="supervisorfilter" :options="supervisorfilterlist" :searchable="true" defaultTitle="All Supervisor" size="sm" class=" w-20 custom-select custom-select-sm" @input="onFilterChangesupervisor()">
                      </VSelect>
             <!--  <b-form-select v-model="supervisorfilter"  @change="onFilterChangesupervisor()" size="sm" class=" w-20">
                <b-form-select-option value="all">All Supervisor</b-form-select-option>
                <b-form-select-option v-for="item in supervisorlist" v-bind:key="item.supervisor_id" :value="item.supervisor_id">{{item.username}}</b-form-select-option>
              </b-form-select> -->	
              
              <b-form-select v-model="complaintypefilter"  @change="onFilterChangeComtype()" size="sm" class=" w-15">
                <b-form-select-option value="all">Complain Type</b-form-select-option>
                <b-form-select-option value="auto">Auto</b-form-select-option>
                <b-form-select-option value="manual">Manual</b-form-select-option>
              
              </b-form-select>
									
								</b-col>
              
                <b-col lg="3" sm="12">
                  <b-form-group
                    label="Filter"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                      </b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-3 pt-3">
                <b-col lg="12">
                  <b-table
                    show-empty
                    sticky-header
                    responsive
                    outlined
                    caption-top
                    hover
                    head-variant="dark"
                    borderless="borderless"
                    id="my-table-live"
                    stacked="md"
                    stickyColumn="scrolled"
               
                    :items="filteredrecords"                  
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    class="scrollH d-flex" 
                  >

                   <!--  :items="records" -->

                 
                  <template v-slot:head(fp_no)="data">                     
                    <span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
                    </span>           
                  </template>
                  <template v-slot:head(ulb)="data">                     
                    <span :title='data.tooltip' v-b-popover.hover.top="'Urban Local Body'" >{{ data.label}}           
                    </span>           
                  </template>
                  <template v-slot:cell(location_title)="row">
												<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
												<b-popover
													:target="`l-${row.item.id}`"
													title="Location"
													triggers="hover focus">
													{{row.item.location_title}}													
												</b-popover>
											</template>
                      <template v-slot:cell(ward_code)="row">
												<span :id="'w-'+row.item.id" pill variant="success">{{row.value}}</span>
												<b-popover
													:target="`w-${row.item.id}`"
													title="Ward"
													triggers="hover focus">
													{{row.item.ward_name}}													
												</b-popover>
											</template>
                    <template v-slot:cell(status)="row">
                      <b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
                      <b-badge pill variant="success" v-else-if="row.value == 1">IN PROGRESS</b-badge>
                      <b-badge pill variant="secondary" v-else-if="row.value == 2">CLOSED</b-badge>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <b-button
                        pill
                        variant="dark"
                        class="mr-1"
                        v-if="$root.chkperm('page_complaint', 'edit')"
                        @click="showUpdateModal(row.item, row.index, $event.target)"
                        size="sm"
                        ><b-icon icon="pencil" font-scale="1"></b-icon
                      ></b-button>
                      <!-- <b-button
                        pill
                        variant="danger"
                        class="mr-1"
                        v-if="$root.chkperm('page_complaint', 'delete')"
                        @click="showDeleteModal(row.item)"
                        size="sm"
                        >DELETE</b-button
                      > -->
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="px-3">
                <b-col lg="6">
                  <span class="mr-2"
                    >Showing {{ currentPage }} to {{ perPage > filteredrecords.length ? filteredrecords.length : perPage }} of
                    {{ filteredrecords.length }} entries</span
                  >
                </b-col>
                <b-col lg="3" offset-md="3">
                  <b-pagination
                    v-model="currentPage"
                    pills
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    prev-text="Prev"
                    next-text="Next"
                    first-number
                    last-number
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- ********************Add/ Edit Complaint model S T A R T ***************************** -->
        <b-modal
          id="my-model"
          :title="selectedItem.id > 0 ? 'Edit Complaint' : 'Add Complaint'"
          ok-only
          @hidden="resetSelectedItem"
          @ok="modalSubmit"
        >
          <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
              label="Subject"
              label-cols="3"
              label-size="sm"
              label-align-sm="right"
              invalid-feedback="Subject is required"
              v-if="$session.get('user_info').role == 1 || selectedItem.id == 0"
            >
              <b-form-select v-model="selectedItem.subject" :options="subjectoptions" :disabled="selectedItem.id > 0">
                <!--<b-form-select-option value="0">Select Subject</b-form-select-option>
							<b-form-select-option value="1">Light OFF</b-form-select-option>
							<b-form-select-option value="2">Lights ON at day time</b-form-select-option>
							<b-form-select-option value="3">Meter Burnt</b-form-select-option>
							<b-form-select-option value="4">MCB Burnt</b-form-select-option>
							<b-form-select-option value="5">Disconnected / Network Issue</b-form-select-option>
							<b-form-select-option value="6">Wire Burn</b-form-select-option>-->
              </b-form-select>
            </b-form-group>
            <!--  <b-form-group
                label="State"
                label-cols="3"
                label-size="sm"
                label-align-sm="right"
                v-if="$session.get('user_info').role == 1"
              >
                <b-form-select
                  v-model="selectedItem.state"
                  :options="$root.state_options"
                  @change="
                    selectedItem.district = 0;
                    selectedItem.ulb = 0;
                  "
                  required
                ></b-form-select>
              </b-form-group> -->
              <!--<b-form-group label="District" label-cols="3" label-size="sm" label-align-sm="right">
              <b-form-select v-model="selectedItem.district" :disabled="selectedItem.id > 0" @change="selectedItem.ulb=0">
                <b-form-select-option value="0">--- Select District ---</b-form-select-option>
                <b-form-select-option v-for="item in filterZone(zones)" v-bind:key="item.id" :value="item.id">{{item.title}}</b-form-select-option>
              </b-form-select>
            </b-form-group>-->
           <!--  <b-form-group
              label="ULB"
              label-cols="3"
              label-size="sm"
              label-align-sm="right"
              v-if="$session.get('user_info').permissions.ulb_perm == ''"
            >
              <b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.id > 0" @change="fetchLocations()">
                <b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
                <b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id">{{
                  item.title
                }}</b-form-select-option>
              </b-form-select>
            </b-form-group> -->

            <!-- <b-form-group label="Location" label-cols="3" label-size="sm" label-align-sm="right">		
            <VSelect v-model="locationfilter" :options="locationsOption" :searchable="true" defaultTitle="" size="sm"  class=" w-100 custom-select custom-select-sm ml-2" @input="setFpno()">
            </VSelect> 
           </b-form-group> -->

           <b-form-group label="Feeder Pillar" label-cols="3" label-size="sm" label-align-sm="right" v-if="selectedItem.id == 0">
              <!-- <b-form-input
                v-model="selectedItem.fp_no"
                required
                maxlength="30"
                :disabled="selectedItem.id > 0"
              ></b-form-input> -->

              <VSelect v-model="fpfilter" :options="fpOption" :searchable="true" defaultTitle="" size="sm"  class=" w-100 custom-select custom-select-sm ml-2 customselectfilter"  @input="setFpno()">
            </VSelect> 
            </b-form-group>
            <b-form-group label="Feeder Pillar" label-cols="3" label-size="sm" label-align-sm="right" v-else>
              <b-form-input
                v-model="selectedItem.fp_no"
                required
                maxlength="30"
                :disabled="selectedItem.id > 0"
              ></b-form-input>
            </b-form-group>

            
           
            <b-form-group
              label="Locations"
              label-cols="3"
              label-size="sm"
              label-align-sm="right"
              v-if="selectedItem.id == 0"
            >
           
            <b-form-input
                v-model="locationfilter"
                required
                maxlength="50"
                disabled
              ></b-form-input>
            <!-- <VSelect v-model="locationfilter" :options="locationsOption" :searchable="true" defaultTitle="" size="sm"  class=" w-100 custom-select custom-select-sm ml-2 customselectfilter"  @input="setFpno()">
            </VSelect> -->   
             <!-- <b-form-select v-model="selectedItem.location" @change="setFpno($event)" :disabled="selectedItem.id > 0" >
                <b-form-select-option value="0">--- Select Location ---</b-form-select-option>
                <b-form-select-option v-for="item in locations" v-bind:key="item.fpno" :value="item.fpno">{{
                  item.location
                }}</b-form-select-option>
              </b-form-select>  -->
            </b-form-group>
            <b-form-group label="Locations" label-cols="3" label-size="sm" label-align-sm="right" v-else>
              <b-form-input
                v-model="selectedItem.location_title"
                required
                maxlength="50"
                :disabled="selectedItem.id > 0"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Supervisor"
              label-cols="3"
              label-size="sm"
              label-align-sm="right"  
              :disabled="  $session.get('user_info').role ==15"       
            >
              <b-form-select v-model="selectedItem.supervisor_id"  >
                <b-form-select-option value="0">--- Select Supervisor ---</b-form-select-option>
                <b-form-select-option v-for="item in supervisorlist" v-bind:key="item.supervisor_id" :value="item.supervisor_id">{{
                  item.username
                }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
           
           <!--  <b-form-group label="Mobile" label-cols="3" label-size="sm" label-align-sm="right">
              <b-form-input
                v-model="selectedItem.mobile"
                required
                maxlength="12"
                :disabled="selectedItem.id > 0"
              ></b-form-input>
            </b-form-group> -->
            <!-- <b-form-group label="Feeder Pillar" label-cols="3" label-size="sm" label-align-sm="right" disabled>
              <b-form-input
                v-model="selectedItem.fp_no"
                required
                maxlength="30"
                :disabled="selectedItem.id > 0"
              ></b-form-input>
            </b-form-group> -->
            <b-form-group label="New Message" label-cols="3" label-size="sm" label-align-sm="right">
              <b-form-textarea
                ref="message"
                v-model="selectedItem.new_message"
                rows="4"
                max-rows="16"
                required
              ></b-form-textarea>
            </b-form-group>
            <b-form-group label="Message" label-cols="3" label-size="sm" label-align-sm="right">
              <b-form-textarea
                v-model="selectedItem.old_message"
                rows="6"
                max-rows="16"
                disabled
                required
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
              label="Status"
              label-cols="3"
              label-size="sm"
              label-align-sm="right"
              v-if="$root.chkperm('page_complaint', 'change_status')"
            >
              <b-form-select v-model="selectedItem.status" :options="statusOptions" required></b-form-select>
            </b-form-group>
          </form>
          <template v-slot:modal-footer="{ ok, close }">
            <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
            <b-button size="sm" variant="success" @click="ok()">{{
              selectedItem.id > 0 ? "Update" : "Submit"
            }}</b-button>
          </template>
        </b-modal>

         <!-- ********************E N D  ***************************** -->
      </b-container>
      <transition name="fade">
        <b-row
          v-if="loading"
          class="loading"
          style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
          align-v="center"
          align-h="center"
        >
          <b-spinner label="Busy" variant="light"></b-spinner>
        </b-row>
      </transition>
    </div>
  </div>
</template>
<script>

/* document.getElementById('my-table-live').on('hover','th',function(){

  console.log('Hover:');
}); */

/* document.getElementById("my-table-live").onmouseover = (function(){ 
  console.log('sdasdas');

}); */
       


import Header from "@/components/Header.vue";
//import VSelect from "@/vue-select-picker-bootstrap";
import VSelect from "vue-select-picker-bootstrap";
export default {
  name: "Complains",
  components: {
    "top-header": Header,
   VSelect
   // "v-select":VSelect,
  },
  mounted() {
    //var self = this;
    //Object.assign(self.selectedItem, self.emptyItem);
    this.initload();
    this.fetchLocations();
    
  },
  data() {
    var self = this;
    return {
      loading: true,
      email: "",
      password: "",
      recordUrl: self.$session.get("apiurl") + "esmartapi/complaint-record",
      insertUrl: self.$session.get("apiurl") + "esmartapi/complaint-insert",
      updateUrl: self.$session.get("apiurl") + "esmartapi/complaint-update",
      deleteUrl: self.$session.get("apiurl") + "esmartapi/complaint-delete",
      locationUrl: self.$session.get("apiurl") + "esmartapi/ulb-locations",
      supervisorUrl: self.$session.get("apiurl") + "esmartapi/getSupervisor-list",
      records: [],
      filteredrecords: [],
      locations: [],
      locationfilter:'',
      locationsOption: [],
      fpfilter:'',
      fpOption: [],
      supervisorlist:[],
      supervisorfilterlist:[],
      wardfilterlist:[],
      statusOptions: [
        { value: 0, text: "NEW" },
        { value: 1, text: "In Progress" },
        { value: 2, text: "Closed" },
      ],
      statusOptionsfilter: [
      { value:'all', text: "All" },
        { value: 0, text: "NEW" },
        { value: 1, text: "In Progress" },
        { value: 2, text: "Closed" },
      ],
      subjectoptions: [
        { value: 0, text: "Select Subject" },
        { value: 7, text: "Signal Loss" },
        { value: 2, text: "Lights ON at day time" },
        { value: 8, text: "Lights OFF at night time" },
        { value: 3, text: "Meter Burnt" },
        { value: 4, text: "MCB Burnt" },
        { value: 5, text: "Disconnected / Network Issue" },
        { value: 6, text: "Wire Burn" },
        { value: 1, text: "Light OFF" }, 
        { value: 9, text: "Door Open" },
        { value: 10, text: "Overload" },   
        { value: 11, text: "Underload" },
        { value: 12, text: "Maintenance" },
        { value: 13, text: "Line Fault" }        
       
      ],
      subjectoptionsFilter: [
        { value: 0, text: "Complaint Type" },
        { value: 7, text: "Signal Loss" },
        { value: 2, text: "Lights ON at day time" },
        { value: 8, text: "Lights OFF at night time" },
        { value: 3, text: "Meter Burnt" },
        { value: 4, text: "MCB Burnt" },
        { value: 5, text: "Disconnected / Network Issue" },
        { value: 6, text: "Wire Burn" },
        { value: 1, text: "Light OFF" },
        { value: 9, text: "Door Open" },
        { value: 10, text: "Overload" },   
        { value: 11, text: "Underload" },
        { value: 12, text: "Maintenance" },
        { value: 13, text: "Line Fault" }         
       
      ],
      selectedfilter:0,
      networkfilter:'all',
      supervisorfilter:'all',
      wardfilter:'all',
      complaintypefilter:'all',
      zones: [],
      wards_list:[],
      zoneOptions: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "fp_no", label: "FP. No.",sortable: true, thStyle:'min-width:80px;', class:'fpno'},
        { key: "supervisor_name", label: "Supervisor", sortable: true,
        formatter: (value) => { 
						if(value== null){							
								return "---";							
						}
						return value;
					}
         },
        { key: "location_title", label: "Location", class: 'text-left', thStyle:'min-width: 135px;',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 15){
								return value.substring(0,15)+"...";
							}
							
						}
						return value;
					},
         },
       /* { key: "imei_no", label: "IMEI NO.",sortable: true },*/
        { key: "ward_code", label: "Ward",sortable: true },        
        {
          key: "subject",
          label: "Complaint Type",thStyle:'min-width:135px;',sortable: true,
          formatter: (value) => {
            var self = this;
            return self.subjectoptions.filter(function(item) {
              if (item.value == value) {
                return item;
              }
            })[0].text;
          },
        }, 
        {
          key: "insert_time",
          label: "Complaint Register Time",sortable: true,  sortDirection: 'desc', class:"text-center", thStyle:'min-width:215px;',
          formatter: (value, key, item) => {
            if (item.insert_time == "") {
              return "00-00-0000 00:00:00";
            }
            return this.$moment(item.insert_time).format("DD-MM-YYYY HH:mm:ss");
          },
        },
        { key: "complain_type", label: "Complain Type", class:"text-center", thStyle:'min-width:117px;'},
        { key: "complain_close_type", label: "Complain Close Type",thStyle:'min-width:157px;',
          formatter: (value) => {
              if (value == "NULL" || value==null || value=='' ) {
                return "----";
              }
              return value;
            }
      
        },
        { key: "complain_close_time", label: "Complain Close Time", sortable: true,  sortDirection: 'desc', class:"text-center", thStyle:'min-width:175px;',
        formatter: (value) => {
              if (value == "NULL" || value==null || value=='' ) {
                return "----";
              }
              return this.$moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
      
        },
       /*  {
          key: "ulb",
          label: "ULB",thStyle:'min-width:130px;',
          formatter: (value) => {
            var self = this;
            return self.zones.filter(function(item) {
              if (item.id == value) {
                return item;
              }
            })[0].title;
          },
        }, */

        /* { key: "mobile", label: "Mobile",thStyle:'min-width:105px;'}, */

        /* {
          key: "update_time",
          label: "Close Time",thStyle:'min-width:146px;',
          formatter: (value, key, item) => {
            if (item.update_time == "") {
              return "00-00-0000 00:00:00";
            }
            return this.$moment(item.update_time).format("DD-MM-YYYY HH:mm:ss");
          },
        }, */
       /*  { key: "read_status", label: "Read Status",thStyle:'min-width:100px;' }, */
        { key: "complain_type", label: "Complain Type" },
        { key: "duration_close", label: "Duration" },        
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions", extra: 1, class: "text-right" },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: { state: this.$session.get("user_info").permissions.state_perm },
      emptyItem: {
        id: 0,
        mobile: "",
        subject: 0,
        message: "",
        status: 0,
      },
      timeData:'(24 Hourse Data )',
      datefrom: '',
      dateto: '',
      closestatus: '',
    };
  },
  methods: {
    filterZone: function(items) {
      var self = this;
      return items.filter(function(item) {
        if (item.parent == 0 && item.state == self.selectedItem.state) {
          return true;
        }
      });
    },
    filterULB: function(items) {
      //var self = this;
      return items.filter(function(item) {
        return item.parent > 0;
      });
      //item.parent == self.selectedItem.district &&
    },
    fetchLocations() {
      var self = this;
      

      self.axios
        .post(self.locationUrl, {
          accesskey: self.$session.get("access_key")
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.locations = response.data.result.locations;
            self.locationsOption=[];
            self.fpOption=[];
           
            self.locations.forEach(function(item) {
              var locOpt = {'value':item.fpno,'text':item.location};
              self.locationsOption.push(locOpt);

              var locOpt2 = {'value':item.fpno,'text':item.fpno};
              self.fpOption.push(locOpt2);
              
            });



          } else {
            console.log("Error in loading locations!");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onFilterChange() {
    //this.records = this.filterChange(this.records);
        /* this.totalRows = this.filteredrecords.length;
      this.currentPage = 1; */

    // this.records = this.networkChange(this.filterChange(this.records));
    this.supervisorfilter = 'all';
    this.wardfilter       = 'all';
    
    this.filteredrecords = this.networkChange(this.filterChange(this.records));
    
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
    },
    onFilterChangesupervisor(){
      this.supervisorfilter =this.supervisorfilter.value;    
      this.filteredrecords = this.filtersupervisorChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    },  
     onFilterChangeward(){
      this.wardfilter =this.wardfilter.value;    
      this.filteredrecords = this.filterwardChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    }, 
    onFilterChangeComtype(){
     // this.complaintypefilter =this.complaintypefilter;    
      this.filteredrecords = this.filtercomtypeChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    },  
    filterChange(devices) {
      var self = this;
      return devices.filter(function(d) {
        //console.log('-----'+self.selectedfilter);
          if (self.selectedfilter ==0) {
            return d;
          }

          if (self.selectedfilter ==1) {
            if (d.subject ==1) {
              return d;
            }
          }

          if (self.selectedfilter==2) {
            if (d.subject == 2) {
              return d;
            }
          }
          if (self.selectedfilter == 3) {
            if (d.subject == 3 ) {
              return d;
            }
          }
          if (self.selectedfilter == 4) {
            if (d.subject == 4 ) {
              return d;
            }
          }
          if (self.selectedfilter == 5) {
            if (d.subject ==5 ) {
              return d;
            }
          }
          if (self.selectedfilter == 6) {
            if (d.subject ==6 ) {
              return d;
            }
          }
          if (self.selectedfilter == 7) {
            if (d.subject ==7 ) {
              return d;
            }
          }
          if (self.selectedfilter == 8) {
            if (d.subject == 8 ) {
              return d;
            }
          }
          if (self.selectedfilter == 9) {
            if (d.subject == 9 ) {
              return d;
            }
          }
          if (self.selectedfilter == 10) {
            if (d.subject == 10 ) {
              return d;
            }
          }
          if (self.selectedfilter == 11) {
            if (d.subject == 11 ) {
              return d;
            }
          }
          if (self.selectedfilter == 12) {
            if (d.subject == 12 ) {
              return d;
            }
          }
           if (self.selectedfilter == 13) {
            if (d.subject == 13 ) {
              return d;
            }
          }
         
          
          
      });
    },
    networkChange(devices){
			var self = this;
      //console.log('-----'+self.networkfilter);
			return devices.filter(function (d) {
				if(self.networkfilter =='all'){
					return d;
				}
				else{
          
					if(self.networkfilter == 0){
						if(d.status ==0){
							return d;
						}
					}
					else if(self.networkfilter == 1){
						if(d.status == 1){
							return d;
						}
					}else if(self.networkfilter == 2){
						if(d.status == 2){
							return d;
						}
					}
				}
			});
		},
    filtersupervisorChange(devices){
      var self = this;
     	return devices.filter(function (d) {         
				if(self.supervisorfilter =='all'){
					return d;
				}
				else{          
					if(self.supervisorfilter == d.supervisor_id){					
							return d;						
					}					
				}
			});      
    },
    filterwardChange(devices){
      var self = this;
     	return devices.filter(function (d) { 
     		if(self.wardfilter =='all'){
					return d;
				}
				else{          
					if(self.wardfilter == d.ward_id){					
							return d;						
					}					
				}
			});
    },
    filtercomtypeChange(devices){
      var self = this;
     	return devices.filter(function (d) { 
     		if(self.complaintypefilter =='all'){
					return d;
				}
				else{          
					if(self.complaintypefilter == d.complain_type){					
							return d;						
					}					
				}
			});
    },
    showAddModal() {
      var self = this;
      //alert(this.$session.get('user_info').permissions.state);
      this.selectedItem = Object.assign({}, this.emptyItem);
      this.selectedItem.state = this.$session.get("user_info").permissions.state_perm;
      self.zones.forEach(function(item) {
        if (String(item.areacode) === String(self.$session.get("user_info").permissions.ulb_perm)) {
          self.selectedItem.ulb = item.id;
        }
      });
      this.$root.$emit("bv::show::modal", "my-model");
      this.fetchLocations();
    },
    showUpdateModal(item, index, button) {
      this.selectedItem = Object.assign({}, item);
      this.selectedItem.old_message =
        "---- Update Time: " + this.$moment(item.update_time).format("DD-MM-YYYY HH:mm:ss") + " ----\n" + item.message;

      //this.$refs.message.selectionStart = 1;

      this.$root.$emit("bv::show::modal", "my-model", button);

      // console.log(this.$refs);
      // this.$refs.message[0].selectionEnd = 1;
    },
    showDeleteModal(item) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete complaint.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            self.axios
              .post(self.deleteUrl, {
                accesskey: self.$session.get("access_key"),
                deleteid: item.id,
              })
              .then(function(response) {
                if (response.data.error == 0 || response.data.error == "0") {
                  self.$bvToast.toast(response.data.message, {
                    title: "Delete",
                    toaster: "b-toaster-bottom-right",
                    autoHideDelay: 5000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                  });
                  self.initload();
                  
                } else if (response.data.error == "2" || response.data.error == 2) {
                  self.$root.forceLogout(response.data.message);
                } else {
                  self.$root.showMessage("Server Error", "Reload again", "ok", function() {
                    self.initload();
                  });
                }
              })
              .catch(function(error) {
                alert(error);
              });
          } else {
            //alert('no '+item.id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = "";
      if (self.selectedItem.id == 0) {
        submitUrl = self.insertUrl;
      } else {
        submitUrl = self.updateUrl;
      }

      self.selectedItem.message = this.selectedItem.new_message + "\n\n" + this.selectedItem.old_message;

      self.axios
        .post(submitUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvModal.hide("my-model");
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            self.initload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    initload() {
      var self = this;
      self.loading = true;
      self.records = [];
      if(self.datefrom!="" ||self.dateto!=""){
        self.closestatus = 2;
        self.timeData= '('+self.datefrom+' to '+self.dateto+')';
       
      }

      self.axios
        .post(self.recordUrl, {
          accesskey: self.$session.get("access_key"),
          ulb: self.$session.get("user_info").permissions.ulb_perm,
          role: self.$session.get('user_info').role,
          datefrom: self.datefrom,
          dateto: self.dateto,
          closestatus:self.closestatus
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            //var filteredarr = self.filtercategory(response.data.result);
            //console.log("Complete Record:::", self.records);
            //console.log("Complete Record response.data.result:::", response.data.result);

            var recordData = response.data.result.complaints;
            self.loading = false;
            self.totalRows = recordData.length;
            
            recordData.forEach(function(item) {
              item.duration_close='---';
              //console.log(item.areacode + " " + self.$session.get("user_info").permissions.ulb_perm);
              if (item.status == 2 && item.complain_close_time!=null && item.complain_close_type!='') {
                    var insertTime = self.$moment(item.insert_time);
                    var closeTime  = self.$moment(item.complain_close_time);
                    //console.log('insertTime:',item.insert_time,"===closeTime",item.complain_close_time);
                    //var timeDiff    = self.$moment.duration(closeTime.diff(insertTime));
                    var timeDiff    =  self.$moment.duration(closeTime.diff(insertTime));

                    var closeDuration='';
                    if(timeDiff.days()>0){
                      closeDuration+= timeDiff.days()+' Day :';
                    }


                     closeDuration+= timeDiff.hours()+' Hr : '+ timeDiff.minutes()+' Min';
                    //var closeDuration = timeDiff.asHours()+' Hr '+ timeDiff.minutes()+' Min';
                   // console.log('====='+'H'+timeDiff.hours()+'=====M:'+timeDiff.minutes());
                  item.duration_close =closeDuration;
              }
               self.records.push(item);
            });



            /*const zoneOptions = arr.reduce((acc, current) => {
              const x = acc.find(item => item.value === current.value);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);*/
            self.zones = response.data.result.zones;
            self.wards_list = response.data.result.wards_list;
            self.zones.forEach(function(item) {
              //console.log(item.areacode + " " + self.$session.get("user_info").permissions.ulb_perm);
              if (String(item.areacode) === String(self.$session.get("user_info").permissions.ulb_perm)) {
                self.selectedItem.ulb = item.id;
              }
            });


          self.wardfilterlist=[];
          self.wardfilterlist.push({'value':'all','text':'All Wards'});
          self.wards_list.forEach(function(row){
            var supList ={'value':row.id,'text':row.areacode};
            self.wardfilterlist.push(supList);
              
          });



          }
          self.filteredrecords = self.networkChange(self.filterChange(self.records));
          // setTimeout(self.initload, 1000 * 30);
        })
        .catch(function(error) {
          console.log(error);
        });
        //alert('login '+self.email+" "+self.password);

        /*  ****** Supervisor list  ****** */
        self.supervisorfilterlist=[];
        self.supervisorfilterlist.push({'value':'all','text':'All Supervisor'});
        self.axios
          .post(self.supervisorUrl, {
            accesskey: self.$session.get("access_key")      
          })
          .then(function(response) {
            if (response.data.error == 0 || response.data.error == "0") {
              self.supervisorlist = response.data.result.supervisor;                 
              self.supervisorlist.forEach(function(row){
                var supList ={'value':row.supervisor_id,'text':row.username};
                self.supervisorfilterlist.push(supList);
                  
              });
                  
            }
          
          })
          .catch(function(error) {
            console.log(error);
          });




    },
    todaycomplaintslist() { 
      this.datefrom = '';
      this.dateto = '';
      this.closestatus = '';
      this.timeData= '(24 Hourse Data)',

      this.initload();
    },
    notClosecomplaintslist() { 
      this.datefrom = '';
      this.dateto = '';
      this.closestatus = 0;
      this.timeData='(Complaint Not Closed List)',
      this.initload();
    },
    /*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadcsv() {
      var self = this;
      var header = new Array();
      self.fields.forEach(function(item) {
        if (!item.extra) {
          header.push(item.label);
        }
      });

      //var d = table.rows().data();
      var finalarr = new Array();
      finalarr.push(header);
      self.filteredrecords.forEach(function(row) {
        var dataarr = new Array();
        self.fields.forEach(function(field) {
          if (field.key != "extra") {
            var rowValue = row[field.key];
            if(field.key=='subject'){

              rowValue = self.subjectoptions.filter(function(item) {
                if (item.value == rowValue) {
                  return item;
                }
              })[0].text;
            }

            if(field.key=='status'){

            rowValue = self.statusOptions.filter(function(item) {
              if (item.value == rowValue) {
                return item;
              }
            })[0].text;
            }

            if(field.key=='ulb'){
              rowValue = 'Jhansi Smart City';
            }
            //console.log('============='+field.key);
            if(field.key == 'location_title'){
            
								if(rowValue == ''){
                  rowValue=''	
								}else{
									if(rowValue!= null){
                    rowValue =rowValue.replaceAll(","," ");
									}else{
										rowValue='';
									}
									
								}
							}

            if(field.key=='ward_id'){
             // rowValue = 'Jhansi Smart City';
              if(rowValue!=''){
										var wardName =  self.wards_list.filter(function (itemm) {
											return itemm.id == rowValue;
										})[0].title;
										dataarr.push(wardName.replace(","," "));
							}
            }

            


            //dataarr.push(row[field.key]);
            dataarr.push(rowValue);
            
          }
        });
        finalarr.push(dataarr);
      });

      let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "complaints_report.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    setFpno(){
      //console.log(event);
      var fp_no 		= this.fpfilter.value;
      var event = fp_no;
      //this.selectedItem.fp_no =event; 
      this.selectedItem.fp_no =fp_no;
      this.selectedItem.location = fp_no;      
      var imeiNo =  this.locations.filter(function (itemm) {
											return itemm.fpno == event;
										})[0].imei_no;
      this.selectedItem.imei_no=imeiNo;
      //console.log(this.selectedItem.imei_no);
      var supervisor_id =  this.locations.filter(function (itemm) {
											return itemm.fpno == event;
										})[0].supervisor_id;
      this.selectedItem.supervisor_id = supervisor_id;
     
      var location =  this.locations.filter(function (itemm) {
											return itemm.fpno == event;
										})[0].location;       
        this.locationfilter = location;
     
      this.initload() ;
    },
    datefilter(){
      if(this.datefrom=='' || this.dateto==''){
        //this.timeData= this.datefrom+' to '+this.dateto;
        var mess = 'Please Select Date';
        this.$bvToast.toast(mess, {
              title: 'Status',
              toaster: 'b-toaster-bottom-right',
              autoHideDelay: 5000,
              variant: 'warning',
              solid: true,
              appendToast: true
            });
      }else{
        //this.loading = true;
        this.initload() ;
      }
      
    }
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-image: url(../assets/home-banner.png) !important;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-position: center center; */
  background-position: bottom;
}

.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
#my-table-live .thead-dark th {
  color: #fff;
  background-color: #ff9a37;
  border-color: #ff9a37;
}
#my-table-live .first-col {
  border-radius: 20px 0px 0px 0px;
  min-width: 130px;
}
#my-table-live .last-cal {
  border-radius: 0px 20px 0px 0px;
  min-width: 153px;
}
.borderRadius20 {
  border-radius: 20px;
}
.table-responsive {
  border-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
}
.customselectfilter button{
  height: 36px;
}

</style>
